export const getI13nModel = () => ({
  category: 'newListing',
  action: 'externalClone_submit',
  label: 'externalClone_submit'
})
